module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0074.jpg?v=8b3d5628";